export const SET_DATA_MODELS = 'dataModel//SET_DATA_MODELS'

interface SetDataModelsAction {
  type: typeof SET_DATA_MODELS
  payload: any
}

export type DataModelsActions = SetDataModelsAction
